import React from 'react'
import Button from 'Elements/Button'
import Slide from 'react-reveal/Slide'

export default function Categories({ data }) {
  return (data.map((category, index1) =>{
    return (
        <Slide bottom>
        <section className='container' key={`category-${index1}`}>
            <h4 className='mb-3 font-weihgt-medium'>
                {category.name}
            </h4>
            <div className='container-grid'>
                {
                    category.items.length === 0 ? (
                        <div className='row'>
                            <div className='col-auto align-item-ceter'>
                                there is no property at this category
                            </div>
                        </div>       
                    ) : (
                        category.items.map((item, index2) => {
                            return(
                                <div className='item column-3 row-1' 
                                key={`category-${index1}-item-${index2}`}>
                                    <div className='card'>
                                        {item.isPopular && (
                                            <div className='tag texr-weight-light'>
                                                Popular Choice
                                            </div>
                                        )}
                                        <figure className='img-wrapper' style={{height: 180}}>
                                            <img src={item.imageUrl} alt={item.name} className='img-cover'/>
                                        </figure>
                                        <div className='meta-wrapper'>
                                            <Button type='link' href={`/properties/${item._id}`} className='streched-link d-blok text-gray-800'>
                                                <h5 className='h4'>{item.name}</h5>
                                            </Button>
                                            <span className='text-gray-500'>{item.city}, {item.country}</span>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )
                }
            </div>
        </section>
        </Slide>
    )
  
}))
}
